import React from "react";
import "../../PettyCashManagement/index.scss";
import { BreadCrumb } from "primereact/breadcrumb";
import SvgDot from "../../../assets/icons/SvgDot";
import { Button } from "primereact/button";
import SvgAdd from "../../../assets/icons/SvgAdd";
import { useNavigate } from "react-router";
import PettyCashReceiptsTable from "./PettyCashReceiptsTable";
import NavBar from "../../../components/NavBar";

const PettyCashReceipts = () => {
  const navigate = useNavigate();
  const items = [
    { label: "Petty Cash", to: "/accounts/pettycash/receipts" },
    {
      label: "Petty Cash Receipts",
      to: "/accounts/pettycash/receipts",
    },
  ];
  const Initiate = { label: "Accounts" };

  const handleClick = () => {
    navigate("/accounts/pettycash/addreceipts");
  };

  return (
    <div className="pettycash__management">
      <div className="grid  m-0">
        <div className="col-12 md:col-6 lg:col-6">
          <div className="pettycash__title">Petty Cash Receipts</div>
          <div>
            <BreadCrumb
              model={items}
              home={Initiate}
              className="breadCrums"
              separatorIcon={<SvgDot color={"#000"} />}
            />
          </div>
        </div>
        <div className="col-12 md:col-6 lg:col-6">
          <div className="btn__container">
            <Button
              label="Receipts"
              icon={<SvgAdd color={"#fff"} />}
              className="add__btn"
              onClick={() => {
                handleClick();
              }}
            />
          </div>
        </div>
      </div>
      <div>
        <PettyCashReceiptsTable />
      </div>
    </div>
  );
};

export default PettyCashReceipts;
